export default __webpack_public_path__ + "maps-examples-multiple-images-960-974b86e71340934482503ded2f0dede7.png";